module.exports = __webpack_public_path__ + "static/media/btn_etikett.7ffdbe57.png";